var _circle, _circle2, _line, _circle3, _rect, _g, _g2, _rect2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRobotLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42,
    cy: 100,
    r: 24,
    fill: "#F59E0B"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 158,
    cy: 100,
    r: 24,
    fill: "#F59E0B"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 25,
    x2: 100,
    y2: 54,
    stroke: "#38BDF8",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 25,
    r: 9,
    fill: "#38BDF8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 50,
    width: 100,
    height: 100,
    rx: 28,
    fill: "#1E293B",
    stroke: "#38BDF8",
    strokeWidth: 6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 88,
    r: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 88,
    r: 10
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#0284C7"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 83,
    cy: 86,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 123,
    cy: 86,
    r: 4
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 118,
    width: 56,
    height: 14,
    rx: 7,
    fill: "#020617"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 80 125             Q 100 135 120 120",
    fill: "none",
    stroke: "#34D399",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 112 120 L 120 120 L 118 128",
    fill: "none",
    stroke: "#34D399",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRobotLogo);
export default __webpack_public_path__ + "static/media/robot-logo.38a63a9b2731a286591c041ab2917055.svg";
export { ForwardRef as ReactComponent };